// extracted by mini-css-extract-plugin
export default {"batchView":"batchView-f59d9675"};